var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNavDocIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.351,
    height: 31.688,
    viewBox: "0 0 25.351 31.688",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.429,6.169H9.169V31.52H28.182v-20.6H23.429ZM9.169,3H25.013l6.338,6.338V31.52a3.169,3.169,0,0,1-3.169,3.169H9.169A3.169,3.169,0,0,1,6,31.52V6.169A3.169,3.169,0,0,1,9.169,3Zm3.169,14.26H25.013v3.169H12.338Zm0,6.338H25.013v3.169H12.338Z",
    transform: "translate(-6 -3)",
    fill: "#2cccd3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavDocIcon);
export default __webpack_public_path__ + "static/media/nav-doc-icon.bf3dbd16.svg";
export { ForwardRef as ReactComponent };